import React, { useEffect, useRef, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BadgeCheck, MailCheck, RefreshCw, XCircle } from "lucide-react";
import BrandMark from "@/components/BrandMark";
import { api } from "@/lib/api";

export default function VerifyEmail() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token") || "";
  const initialEmail = searchParams.get("email") || "";
  const started = useRef(false);
  const [email, setEmail] = useState(initialEmail);
  const [status, setStatus] = useState(token ? "loading" : "waiting");
  const [message, setMessage] = useState(token ? "Memverifikasi alamat email…" : "Periksa inbox dan folder spam untuk menemukan email verifikasi KRAYA.");
  const [resending, setResending] = useState(false);

  useEffect(() => {
    if (!token || started.current) return;
    started.current = true;
    api.post("/auth/verify-email", { token })
      .then((response) => {
        setStatus("success");
        setMessage(response.data?.message || "Email berhasil diverifikasi.");
      })
      .catch((error) => {
        setStatus("error");
        setMessage(error?.response?.data?.detail || "Tautan verifikasi tidak valid atau telah kedaluwarsa.");
      });
  }, [token]);

  const resend = async (event) => {
    event.preventDefault();
    setResending(true);
    try {
      const response = await api.post("/auth/resend-verification", { email: email.trim() });
      setStatus("waiting");
      setMessage(response.data?.message || "Email verifikasi akan dikirim jika akun memenuhi syarat.");
    } catch (error) {
      setStatus("error");
      setMessage(error?.response?.data?.detail || "Email verifikasi belum dapat dikirim.");
    } finally {
      setResending(false);
    }
  };

  const Icon = status === "success" ? BadgeCheck : status === "error" ? XCircle : MailCheck;
  const iconClass = status === "success" ? "bg-emerald-50 text-emerald-600" : status === "error" ? "bg-rose-50 text-rose-600" : "bg-blue-50 text-blue-600";

  return (
    <div className="relative min-h-screen overflow-hidden bg-slate-950 text-slate-100">
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_20%_20%,rgba(34,211,238,.18),transparent_30%),radial-gradient(circle_at_80%_80%,rgba(99,102,241,.22),transparent_34%)]" />
      <div className="relative mx-auto flex min-h-screen max-w-7xl items-center justify-center p-5 sm:p-8">
        <div className="w-full max-w-md rounded-[2rem] border border-white/10 bg-white p-6 text-center text-slate-950 shadow-2xl shadow-black/30 sm:p-9">
          <Link to="/" className="inline-flex"><BrandMark accentClassName="text-blue-600" /></Link>
          <div className={`mx-auto mt-8 flex h-14 w-14 items-center justify-center rounded-2xl ${iconClass}`}>
            <Icon className={`h-7 w-7 ${status === "loading" ? "animate-pulse" : ""}`} />
          </div>
          <h1 className="mt-5 font-display text-4xl font-black tracking-[-0.05em]">Verifikasi email.</h1>
          <p className="mt-3 text-sm leading-6 text-slate-500">{message}</p>

          {status === "success" ? (
            <Link to="/login" className="mt-7 inline-flex w-full items-center justify-center rounded-2xl bg-emerald-600 py-3.5 text-sm font-bold text-white">Login ke KRAYA</Link>
          ) : status !== "loading" ? (
            <form onSubmit={resend} className="mt-7 space-y-4 text-left">
              <div>
                <label className="mb-2 block text-sm font-semibold text-slate-700">Alamat email</label>
                <input type="email" required autoComplete="email" value={email} onChange={(event) => setEmail(event.target.value)} className="w-full rounded-2xl border border-slate-200 bg-slate-50 px-4 py-3.5 text-sm outline-none focus:border-blue-500 focus:bg-white focus:ring-4 focus:ring-blue-100" placeholder="nama@bisnis.com" />
              </div>
              <button type="submit" disabled={resending} className="flex w-full items-center justify-center gap-2 rounded-2xl bg-slate-950 py-3.5 text-sm font-bold text-white hover:bg-blue-600 disabled:opacity-50"><RefreshCw className={`h-4 w-4 ${resending ? "animate-spin" : ""}`} /> {resending ? "Mengirim…" : "Kirim Ulang Verifikasi"}</button>
            </form>
          ) : null}

          <div className="mt-7 border-t border-slate-200 pt-6 text-sm text-slate-500"><Link to="/login" className="font-bold text-blue-600">Kembali ke login</Link></div>
          <div className="mt-6 text-[11px] uppercase tracking-[0.16em] text-slate-400">Powered By AntSoft ID</div>
        </div>
      </div>
    </div>
  );
}
